//import "swiffy-slider/css"
//import chroma from "chroma-js"
//import './main.scss'

import accordion from './js/accordion.js'
import logo from './js/logo.js'
import navigation from './js/navigation.js'
import formDropdown from './js/form-dropdown.js'
import formIndustry from './js/form-industry.js'
//import sliders from './js/slider.js'
import HistorySlider from './js/sliders/HistorySlider.js'
import HomeSlider from './js/sliders/HomeSlider.js'
import FaqSlider from "./js/sliders/FaqSlider.js";

accordion.init()
logo.init();
navigation.init()
formDropdown.init()
formIndustry.init()
//sliders.init()
HomeSlider.init()
HistorySlider.init()
FaqSlider.init()



// Converts image to canvas; returns new canvas element
// function convertImageToCanvas(image) {
//   const canvas = document.createElement('canvas');
//   canvas.width = image.width;
//   canvas.height = image.height;
//   const ctx = canvas.getContext('2d');
//   ctx.drawImage(image, 0, 0);
//
//   image.replaceWith(canvas);
//
//   const sftBlue = chroma.rgb(0, 94, 202);
//
//   const imageData = ctx.getImageData(0, 0, image.width, image.height);
//
//   const data = imageData.data;
//   for (let i = 0; i < data.length; i += 4) {
//     // Better  ( (0.3 * R) + (0.59 * G) + (0.11 * B) ).
//     const avg = (data[i] + data[i + 1] + data[i + 2]) / 3;
//     //console.log(avg);
//     // data[i] = avg; // red
//     // data[i + 1] = avg * 1.5; // green
//     // data[i + 2] = avg * 2; // blue
//
//     //data[i] = 0;
//     //data[i + 1] = (avg / 255) * 36 * 2.5;
//     //data[i + 2] = (avg / 255) * 79 * 2.5;
//
//     //data[i] = avg;
//     //data[i + 1] = (avg / 255) * 36 * 2.5;
//     //data[i + 2] = (avg / 255) * 79 * 2.5;
//
//     const color = chroma.rgb(data[i], data[i + 1], data[i + 2]);
//     const luminance = color.luminance();
//     const luminatedBlue = sftBlue.luminance(luminance);
//
//     data[i] = luminatedBlue.get('rgb.r');
//     data[i + 1] = luminatedBlue.get('rgb.g');
//     data[i + 2] = luminatedBlue.get('rgb.b');
//   }
//   ctx.putImageData(imageData, 0, 0);
//
//
//   //return canvas;
// }
/*
const newsImages = document.querySelectorAll('.news__image');
newsImages.forEach((image) => {
  convertImageToCanvas(image);
});
console.log(newsImages);
*/
